import GTBank from 'src/assets/img/beneficiaryBanks/GTBank.svg'
import ZenithBank from 'src/assets/img/beneficiaryBanks/zenith.svg'
import Wema from 'src/assets/img/beneficiaryBanks/wema.svg'
import FirstBank from 'src/assets/img/beneficiaryBanks/firstbank.svg'
import GTBankMd from 'src/assets/img/banks/gtbank.svg'
import FirstBankMd from 'src/assets/img/banks/first-bank.svg'
import ZenithMd from 'src/assets/img/banks/zenith.svg'
import MastercardLogo from 'src/assets/img/mastercard-logo.svg'
import OpayLogo from 'src/assets/img/opay-icon.svg'
import visaLogo from 'src/assets/img/visa-icon.svg'
import FirstBankLg from 'src/assets/img/banks/firstbank-lg.svg'


export const banksImgSm = <any>{
    'GTBank': GTBank,
    'Zenith Bank': ZenithBank,
    'Wema Bank': Wema,
    'First Bank': FirstBank
}

export const banksImgMd = <any>{
    'GTBank': GTBankMd,
    'Zenith Bank': ZenithMd,
    'First Bank': FirstBankMd
}

export const banksImgLg = <any>{
    'First Bank': FirstBankLg
}

export const cardTypes = <any> {
    'Visa': visaLogo,
    'MasterCard': MastercardLogo,
    'Opay': OpayLogo
}
